(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-cart"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Qty buttons — update input value, no form submit on click */
  document.querySelectorAll('[data-sp-cart-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.dataset.spCartQty, 10);
      var key   = btn.dataset.key;
      var input = document.querySelector('.sp-cart__qty-input[data-key="' + key + '"]');
      if (!input) return;
      var val  = parseInt(input.value, 10) || 0;
      var next = Math.max(0, Math.min(999, val + delta));
      input.value = next;
      /* Auto-submit after 600ms idle */
      clearTimeout(input._spTimer);
      input._spTimer = setTimeout(function () {
        var form = document.getElementById('sp-cart-form');
        if (form) form.submit();
      }, 600);
    });
  });

  /* Input change → delayed submit */
  document.querySelectorAll('.sp-cart__qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      clearTimeout(input._spTimer);
      input._spTimer = setTimeout(function () {
        var form = document.getElementById('sp-cart-form');
        if (form) form.submit();
      }, 600);
    });
  });

  /* ── Calculadora de frete (taxas reais via carrier service / Frenet) ── */
  var cepInput  = document.querySelector('[data-sp-cep-input]');
  var cepBtn    = document.querySelector('[data-sp-cep-submit]');
  var cepResult = document.querySelector('[data-sp-shipping-result]');

  function spFormatCep(value) {
    var digits = value.replace(/\D/g, '').slice(0, 8);
    if (digits.length > 5) return digits.slice(0, 5) + '-' + digits.slice(5);
    return digits;
  }

  function spEscapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function spRenderShippingError(message) {
    if (cepResult) cepResult.innerHTML = '<p class="sp-cart__shipping-calc-error">' + message + '</p>';
  }

  function spRenderShippingRates(rates, addr) {
    if (!cepResult) return;
    if (!rates || !rates.length) {
      spRenderShippingError('Nenhuma opção de frete encontrada para este CEP. Tente novamente no checkout.');
      return;
    }
    var html = '';
    if (addr && addr.city) {
      html += '<p class="sp-cart__shipping-calc-dest">Entrega em ' + spEscapeHtml(addr.city) + ' / ' + spEscapeHtml(addr.province) + '</p>';
    }
    html += '<ul class="sp-cart__shipping-calc-list">';
    rates.forEach(function (rate) {
      var price = (parseFloat(rate.price) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      html += '<li class="sp-cart__shipping-calc-item"><span>' + spEscapeHtml(rate.name || rate.title || 'Frete') + '</span><strong>' + price + '</strong></li>';
    });
    html += '</ul>';
    cepResult.innerHTML = html;
  }

  /*
   * Params compartilhados entre prepare e async — precisam ser IDENTICOS.
   * A transportadora (carrier service) so consegue cotar com o endereco
   * razoavelmente completo: enviar apenas CEP + pais devolve lista vazia.
   * Por isso cidade e estado sao descobertos pelo CEP antes de cotar.
   */
  function spShippingParams(addr) {
    return 'shipping_address%5Bzip%5D=' + encodeURIComponent(addr.zip) +
           '&shipping_address%5Bcountry%5D=Brazil' +
           '&shipping_address%5Bprovince%5D=' + encodeURIComponent(addr.province || '') +
           '&shipping_address%5Bcity%5D=' + encodeURIComponent(addr.city || '');
  }

  /* Mapa UF -> nome do estado (o Shopify espera o nome por extenso) */
  var SP_UF = {
    AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia',
    CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás',
    MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul',
    MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná',
    PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro',
    RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia',
    RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo',
    SE: 'Sergipe', TO: 'Tocantins'
  };

  /* Consulta ViaCEP para obter cidade/estado. Resolve com null se falhar. */
  function spLookupCep(zip) {
    return fetch('https://viacep.com.br/ws/' + zip + '/json/')
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || data.erro) return null;
        return {
          zip: zip,
          city: data.localidade || '',
          province: SP_UF[data.uf] || ''
        };
      })
      .catch(function () { return null; });
  }

  /*
   * async_shipping_rates devolve `null` no corpo enquanto o cálculo não
   * termina — nesse caso é preciso continuar consultando.
   */
  function spPollShippingRates(addr, attempt) {
    attempt = attempt || 0;
    if (attempt > 15) {
      spRenderShippingError('Não foi possível calcular agora. O frete é calculado normalmente no checkout.');
      return;
    }
    fetch('/cart/async_shipping_rates.json?' + spShippingParams(addr), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data === null || typeof data !== 'object') {
          setTimeout(function () { spPollShippingRates(addr, attempt + 1); }, 800);
          return;
        }
        spRenderShippingRates(data.shipping_rates, addr);
      })
      .catch(function () {
        spRenderShippingError('Não foi possível calcular agora. O frete é calculado normalmente no checkout.');
      });
  }

  if (cepInput) {
    cepInput.addEventListener('input', function () {
      cepInput.value = spFormatCep(cepInput.value);
    });
    cepInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        cepBtn && cepBtn.click();
      }
    });
  }

  if (cepBtn) {
    cepBtn.addEventListener('click', function () {
      var zip = (cepInput && cepInput.value || '').replace(/\D/g, '');
      if (zip.length !== 8) {
        spRenderShippingError('Digite um CEP válido.');
        return;
      }

      cepBtn.disabled = true;
      if (cepResult) cepResult.innerHTML = '<p class="sp-cart__shipping-calc-loading">Calculando frete…</p>';

      /* 1) descobre cidade/estado pelo CEP  2) cota o frete */
      spLookupCep(zip)
        .then(function (addr) {
          if (!addr) {
            spRenderShippingError('Não conseguimos validar esse CEP. Confira o número ou calcule o frete no checkout.');
            return null;
          }
          /* prepare_shipping_rates exige POST */
          return fetch('/cart/prepare_shipping_rates.json?' + spShippingParams(addr), {
            method: 'POST',
            headers: { 'Accept': 'application/json' }
          }).then(function () { spPollShippingRates(addr, 0); });
        })
        .catch(function () {
          spRenderShippingError('Não foi possível calcular agora. O frete é calculado normalmente no checkout.');
        })
        .then(function () { cepBtn.disabled = false; });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sp-search"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Sort by — update URL preserving q param */
  var sortSel = document.querySelector('[data-sp-search-sort]');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
